export const COLORS = {
  ARCTIC: "#F6F7EB",
  MIDNIGHT: "#393E41",
  FIERY: "#E94F37",

  MIDNIGHT_70: "rgba(57, 62, 65, 0.7)",
  MIDNIGHT_15: "rgba(57, 62, 65, 0.15)",
  FIERY_HOVER: "#D84330",
};
